const onDocumentReady = (callback) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
    return;
  }

  callback();
};

onDocumentReady(() => {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-collection-scroll]');
    if (!trigger) return;

    const targetId = trigger.getAttribute('data-collection-scroll');
    if (!targetId) return;

    const target = document.getElementById(targetId);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  const detailPanels = document.querySelectorAll('.custom-collection-seo-body__details');
  for (const panel of detailPanels) {
    const label = panel.querySelector('[data-summary-label]');
    if (!label) continue;

    const collapsedLabel = panel.dataset.collapsedLabel;
    const expandedLabel = panel.dataset.expandedLabel;

    const syncLabel = () => {
      if (!collapsedLabel || !expandedLabel) return;
      label.textContent = panel.open ? expandedLabel : collapsedLabel;
    };

    syncLabel();
    panel.addEventListener('toggle', syncLabel);
  }
});

